import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { ILocalAdminActions, IThunkArchiveLocalAdmin } from '../types';

const onRestoreLocalAdmin: IThunkArchiveLocalAdmin = thunk(
  async ({ restoreLocalAdmin }: Actions<ILocalAdminActions>, payload) => {
    const { clinicId, localAdminId } = payload;

    await api.localAdmin.restoreLocalAdmin(clinicId, localAdminId);

    restoreLocalAdmin(localAdminId);
  },
);

export default onRestoreLocalAdmin;
